import { usePledgeTeamsQuery } from '../data-access';
import { getWCPledgeTeamFlagUrl } from '../util';

import { useWCPledgeCampaignDetails } from './useWCPledgeCampaignDetails';
import { useWCPledgeRates } from './useWCPledgeRates';

type UseWCPledgeTeamsListProps = {
	withinActiveCampaign?: boolean;
};

export const useWCPledgeTeamsList = ({ withinActiveCampaign = true }: UseWCPledgeTeamsListProps = {}) => {
	const { campaignId, isPledgeCampaignDetailsLoading } = useWCPledgeCampaignDetails({
		enabled: withinActiveCampaign
	});

	const {
		data,
		isError,
		isLoading: isTeamsLoading
	} = usePledgeTeamsQuery({
		options: { enabled: !withinActiveCampaign || Boolean(campaignId) },
		params: {
			campaignIds: withinActiveCampaign ? (campaignId ? [campaignId] : undefined) : [],
			'details[]': ['teamImages']
		}
	});

	const fetchedTeamWithCountry = data ?? [];
	const { usdToChzRate } = useWCPledgeRates();

	const teamList = fetchedTeamWithCountry.map(team => ({
		...team,
		flagUrl: getWCPledgeTeamFlagUrl(team),
		priceInCHZ: team.priceInUSD ? Number(team.priceInUSD) * (usdToChzRate ?? 0) : undefined
	}));

	return { isError, isLoading: isPledgeCampaignDetailsLoading || isTeamsLoading, teamList };
};
